/** Settle the first workspace color before enabling navigation transitions. */
export function initializeLogoTransitions(logo: HTMLDivElement | null) {
  if (!logo) {
    return;
  }

  const root = logo.ownerDocument.documentElement;

  if (root.hasAttribute("data-logo-transitions")) {
    return;
  }

  // Flush the initial, unanimated color while React's theme markers are present.
  // Otherwise the document can transition from the shared blue startup palette.
  getComputedStyle(root).getPropertyValue("--app-logo-background");
  root.setAttribute("data-logo-transitions", "");
}
